import React, { useEffect, useState } from "react";
import { BreadCrumbSecttion } from "../component/BreadCrumbSecttion";
import { Col, Container, Row } from "react-bootstrap";
import InputField from "../component/InputField";
import { useLocation, useParams, useNavigate } from "react-router-dom";
import PurchaseService from "../services/Purchase";
import SelectDropDown from "../component/SelectDropDown";
import ProfileService from "../services/Profile";
import toast from "react-hot-toast";
import ConfirmationModal from "../component/Modals/ConfirmationModal";
import ColoredButton from "../component/ColoredButton";
import RegistrationService from "../services/registration";
import PrimaryGradientButton from "../component/PrimaryGradientButton";

const AddressApproval = () => {
  // const [inputEditable, set]
  const location = useLocation();
  const addressData = location.state?.addressData || {};
  const navigate = useNavigate();

  const [editable, setEditable] = useState(false); 

  const [selectedResidence, setSelectedResidence] = useState({ id: "", title: "" });
  const [line1, setLine1] = useState("");       
  const [line2, setLine2] = useState("");       
  const [line3, setLine3] = useState("");       
  const [pincode, setPincode] = useState("");   
  const [selectedState, setSelectedState] = useState({ id: "", title: "" });      
  const [selectedDistrict, setSelectedDistrict] = useState({ id: "", title: "" }); 

  const [contentCountry, setContentCountry] = useState({ id: "", title: "" });
  const [isStateList, setIsStateList] = useState([]);
  const [isDistrictList, setIsDistrictList] = useState([]);
  const [contentState, setContentState] = useState({ id: "", title: "" }); 
  const [loading, setLoading] = useState(false);

  const [contactpersonName, setContactpersonName] = useState("");
  const [contactPersonPhone, setContactPersonPhone] = useState("");
  const [contactPersonEmail, setContactPersonEmail] = useState("");

  React.useEffect(() => {
    if (addressData) {
      
      setSelectedResidence((prev) => prev.id ? prev : {
        id: addressData.address_type || "", title: addressData.address_type_title || ""
      });

      setLine1((prev) => prev || addressData.line1 || "");
      setLine2((prev) => prev || addressData.line2 || "");
      setLine3((prev) => prev || addressData.line3 || "");
      setPincode((prev) => prev || addressData.post_code || "");

      setContactpersonName((prev) => prev || addressData.sales_office_contact_person_name || "");
      setContactPersonPhone((prev) => prev || addressData.sales_office_contact_phone || "");
      setContactPersonEmail((prev) => prev || addressData.sales_office_contact_email || "");

      if (!selectedState?.id && addressData.state_id) {
        const initState = { id: addressData.state_id, title: addressData.state_name || "" };
        setSelectedState(initState);
        setContentState(initState); 
      }
      if (!selectedDistrict?.id && addressData.district_id) {
        setSelectedDistrict({ id: addressData.district_id, title: addressData.district_name || "" });
      }
    }
  }, [addressData]); 

  React.useEffect(() => {
    const fetchCountryData = async () => {
      try {
        const response = await RegistrationService.allCountries();
        if (response.success && response.response.countriesDetails.length > 0) {
          const india = response.response.countriesDetails.find((c) => c.name === "India");
          if (india) setContentCountry({ id: india.id, title: india.name });
        }
      } catch (e) { console.error("Error"); }
    };
    fetchCountryData();
  }, []);

  React.useEffect(() => {    
    if (selectedResidence.id == "branch_office") {
      setSelectedState({ id: addressData.sales_office_state_id ? addressData.sales_office_state_id : '', title: addressData.sales_office_state_name ? addressData.sales_office_state_name : ''});
      setSelectedDistrict({ id: addressData.sales_office_district_id??'', title: addressData.sales_office_district_name??'' });
      setLine1(addressData.sales_office_address_line1);
      setLine2(addressData.sales_office_address_line2);
      setLine3(addressData.sales_office_address_line3);
      setPincode(addressData.sales_office_post_code);

    } else {
      setSelectedState({ id: addressData.state_id??'', title: addressData.state_name??'' });
      setSelectedDistrict({id: addressData.district_id??'', title: addressData.district_name??''});
      setLine1(addressData.line1);
      setLine2(addressData.line2);
      setLine3(addressData.line3);
      setPincode(addressData.post_code);
    }
  }, [selectedResidence]);

  React.useEffect(() => {
    const stateListFetch = async () => {
      if (contentCountry.id) {
        try {
          const res = await RegistrationService.allStates(contentCountry.id);
          if (res.success && res.response.statesDetails.length > 0) {
            setIsStateList(res.response.statesDetails.map((s) => ({ id: s.id, title: s.name })));
          }
        } catch (e) { console.error("Error"); }
      }
    };
    stateListFetch();
  }, [contentCountry.id]);

  React.useEffect(() => {
    const fetchDistrictList = async () => {
      if (contentCountry.id && contentState.id) {
        try {
          const token = localStorage.getItem("access_token");
          const res = await RegistrationService.allDistricts(contentCountry.id, contentState.id, token);
          if (res.success && res.response.districtDetails.length > 0) {
            setIsDistrictList(res.response.districtDetails.map((d) => ({ id: d.id, title: d.name })));
          } else {
            setIsDistrictList([]); 
          }
        } catch (e) { console.error("Error"); }
      }
    };
    fetchDistrictList();
  }, [contentCountry.id, contentState.id]); 

  const handleEditClick = () => {
    setEditable(true); 
    setSelectedDistrict({ id: "", title: "" });
  };

  
  const savePurchase = async () => {
    const selectedOption = localStorage.getItem("selectedOption");
    const payload = {
      orderId: addressData.order_id,
      // addressId: addressData.address_id,
      addressId: (selectedResidence.id === "branch_office") ? addressData.sales_office_address_id : addressData.address_id,
      status: "modify",
      addressType: selectedResidence.id,
      // line1,      
      line1: (selectedResidence.id === "branch_office") ? addressData.sales_office_address_line1 : addressData.line1,
      line2: (selectedResidence.id === "branch_office") ? addressData.sales_office_address_line2 : addressData.line2,
      line3: (selectedResidence.id === "branch_office") ? addressData.sales_office_address_line3 : addressData.line3,
      // city: selectedDistrict.id,  
      city: (selectedResidence.id === "branch_office") ? addressData.sales_office_district_id : selectedDistrict.id,
      // districtId: selectedDistrict.id, 
      districtId: (selectedResidence.id === "branch_office") ? addressData.sales_office_district_id : selectedDistrict.id,
      // stateId: selectedState.id,       
      stateId: (selectedResidence.id === "branch_office") ? addressData.sales_office_state_id : selectedState.id,
      countryId: 100,
      // pincode,                    
      pincode: (selectedResidence.id === "branch_office") ? addressData.sales_office_post_code : addressData.post_code,
    };

    if (!selectedState.id || !selectedDistrict.id || !pincode || !line1 || !selectedResidence.id) {
      toast.error("Please select all the required fields");
      return;
    }

    try {
      setLoading(true);
      // const res = {success: true}
      const res = await PurchaseService.updateAddress(payload);
      setLoading(false);
      if (res.success) {
        toast.success("Approved successfully");
        setEditable(false);
        setTimeout(() => navigate(`/address-approval-list`, {state: JSON.parse(localStorage.getItem('selectedOption'))}), 1500);
      }
    } catch (err) {
      setLoading(false);
      toast.error("Something went wrong. Please try again.");
    }
  };

  const handleBack = (item) => {
    navigate(`/address-approval-list`,{ state: JSON.parse(localStorage.getItem('selectedOption'))});
  };

  const handleDeliveryTypeChange = (selected) => {
    if(selected.id === "residential") {
      setEditable(true);
      setLine1(addressData.line1);
    } else { 
      setEditable(false);
      // setLine1(addressData.sales_office_address_line1);
      // setLine2(addressData.sales_office_address_line2);
      // setLine3(addressData.sales_office_address_line3);
      // setSelectedState(addressData.sales_office_state_name);
      // setPincode(addressData.sales_office_post_code);
    }
  }


  return (
    <>
      <BreadCrumbSecttion pageTitle="Address Approval" currentPageName="Address Approval" />
      <section className="padTop50">
        <Container>
          <Row className="justify-content-center align-item-center h-100">
            <Col xs={12}>
              <div className="userInfoBox">
                {/* <div className="dashboard-title" style={{display: "flex"}}>
                  <h4>Name: {addressData.contractor_name}</h4> &nbsp; &nbsp;
                   <h4>Mob: {addressData.contractor_phone}</h4> &nbsp; &nbsp;
                   <h4>Member code: {addressData.external_id}</h4>
                </div> */}
                <div className="dashboard-title" style={{ display: "flex" }}>
                  <h4>
                    <span style={{ fontWeight: "bold" }}>Name: </span>
                    <span style={{ fontWeight: "lighter", color: "#6c757d" }}>{addressData.contractor_name}</span>
                  </h4>
                  &nbsp;&nbsp;
                  <h4>
                    <span style={{ fontWeight: "bold" }}>Mob: </span>
                    <span style={{ fontWeight: "lighter", color: "#6f7478ff" }}>{addressData.contractor_phone}</span>
                  </h4>
                  &nbsp;&nbsp;
                  <h4>
                    <span style={{ fontWeight: "bold" }}>Member code: </span>
                    <span style={{ fontWeight: "lighter", color: "#6c757d" }}>{addressData.external_id}</span>
                  </h4>
                </div>

                <div className="dashboard-title"><h4>Address Edit</h4></div>
                <div className="dashboard-details purchaseApprovalWrap">
                  <Row>
                    <Col xs={12} lg={3}>
                      <SelectDropDown
                        labelName="Delivery Type"
                        requiredStar="*"
                        options={[
                          { id: "residential", title: "Home Delivery" },
                          { id: "branch_office", title: "Branch Office Delivery" },
                        ]}
                        selectedValue={selectedResidence}
                        setSelectedValue={setSelectedResidence}
                        page="searchFilter"
                        // disabled={selectedResidence ! } 
                        onChange={handleDeliveryTypeChange}
                      />
                    </Col>

                    <Col xs={12} lg={3}>
                      <InputField
                        inputFieldLabel="Address Line 1"
                        requiredStar="*"
                        name="line1"
                        value={line1}                      
                        onChange={(e) => setLine1(e.target.value)} 
                        editable={editable}               
                      />
                    </Col>

                    <Col xs={12} lg={3}>
                      <InputField
                        inputFieldLabel="Address Line 2"
                        // requiredStar="*"
                        name="line2"
                        value={line2}                      
                        onChange={(e) => setLine2(e.target.value)}
                         editable={editable}              
                      />
                    </Col>
                    
                    <Col xs={12} lg={3}>
                      <InputField
                        inputFieldLabel="Address Line 3"
                        // requiredStar="*"
                        name="line3"
                        value={line3}                      
                        onChange={(e) => setLine3(e.target.value)} 
                         editable={editable}             
                      />
                    </Col>

                    <Col xs={12} lg={3}>
                      <SelectDropDown
                        labelName="State"
                        requiredStar="*"
                        options={isStateList}
                        selectedValue={selectedState}
                        setSelectedValue={(opt) => {
                          setSelectedState(opt);          
                          setContentState(opt);  
                          setSelectedDistrict({ id: "", title: "" }); 
                        }}
                        disabled={!editable}
                      />
                    </Col>

                    <Col xs={12} lg={3}>
                      <SelectDropDown
                        labelName="District"
                        requiredStar="*"
                        options={isDistrictList}
                        selectedValue={selectedDistrict}
                        setSelectedValue={setSelectedDistrict} 
                        disabled={!editable}
                      />
                    </Col>

                    <Col xs={12} lg={3}>
                      <InputField
                        inputFieldLabel="Pincode"
                        requiredStar="*"
                        name="pincode"
                        value={pincode}                 
                        onChange={(e) => setPincode(e.target.value)} 
                         editable={editable}              
                      />
                    </Col>

                    {selectedResidence.id === "branch_office" && (
                      <>
                      <Col xs={12} lg={3}>
                      <InputField
                        inputFieldLabel="Contact Person Name"
                        // requiredStar="*"
                        name="name"
                        value={contactpersonName}                      
                        onChange={(e) => setContactpersonName(e.target.value)} 
                         editable={editable}             
                      />
                    </Col>

                    <Col xs={12} lg={3}>
                      <InputField
                        inputFieldLabel="Contact Person Phone"
                        // requiredStar="*"
                        name="phone"
                        value={contactPersonPhone}                      
                        onChange={(e) => setContactPersonPhone(e.target.value)} 
                         editable={editable}             
                      />
                    </Col>

                    <Col xs={12} lg={3}>
                      <InputField
                        inputFieldLabel="Contact Person Email"
                        // requiredStar="*"
                        name="email"
                        value={contactPersonEmail}                      
                        onChange={(e) => setContactPersonEmail(e.target.value)} 
                         editable={editable}             
                      />
                    </Col>
                    </>
                    )}

                  </Row>

                  <Container style={{ display: "flex", gap: 20, marginTop: 30 }}>
                    {/* {!editable && (
                      <Col xs={3}>
                        <ColoredButton className={"yellow-btn"} buttonText={"Edit"} onClick={handleEditClick} />
                      </Col>
                    )} */}
                    {
                      <Col xs={3}>
                        <ColoredButton className={"yellow-btn"} buttonText={"Back"} onClick={handleBack} />
                      </Col>
                    }
                    <Col xs={3}>
                    {/* <div className="pendingStatusBlock"></div> */}
                      <ColoredButton
                        className={"green-btn"}
                        buttonText={loading ? "Processing..." : editable ? "Approve" : "Approve"}
                        onClick={editable ? savePurchase : savePurchase} 
                      />
                    </Col>
                  </Container>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default AddressApproval;
